export default "__VITE_ASSET__Wu5Yr1id__"